import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/HubspotDealNameMcp.graphql';
import { Query, QueryhubspotDealNameMcpArgs } from '../../__generated__/globalTypes';

export const useHubspotDealNameMcpQuery = (options?: QueryHookOptions<Query, QueryhubspotDealNameMcpArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryhubspotDealNameMcpArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useHubspotDealNameMcpLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryhubspotDealNameMcpArgs>
): QueryResult<Query, QueryhubspotDealNameMcpArgs> & {
  getHubspotDealNameMcp: LazyQueryExecFunction<Query, QueryhubspotDealNameMcpArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getHubspotDealNameMcp, result] = useLazyQuery<Query, QueryhubspotDealNameMcpArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getHubspotDealNameMcp, ...result };
};

export const useHubspotDealNameMcpPromiseQuery = () => {
  const client = useApolloClient();

  const getHubspotDealNameMcp = useCallback(
    (options?: Omit<QueryOptions<QueryhubspotDealNameMcpArgs, Query>, 'query'>) =>
      client.query<Query, QueryhubspotDealNameMcpArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getHubspotDealNameMcp };
};
// Suspense Query Hooks
export const useHubspotDealNameMcpSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryhubspotDealNameMcpArgs>
) => {
  const result = useSuspenseQuery<Query, QueryhubspotDealNameMcpArgs>(QUERY, {
    ...options
  });

  return result;
};
